var map = {
	"./CSharp.png": "04e2",
	"./Cordova.png": "09af",
	"./HTML5.png": "7b81",
	"./JavaScript.png": "bf74",
	"./Love2D.png": "8443",
	"./Lua.png": "2d88",
	"./Mocha.png": "727b",
	"./NodeJS.png": "9558",
	"./Photoshop.png": "3342",
	"./ReactJS.png": "1bcb",
	"./SASS.png": "568e",
	"./SEO.png": "f0bb",
	"./Sketch.png": "1643",
	"./UIUX.png": "8254",
	"./Unity.png": "e910",
	"./VueJS.png": "295f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b552";